<i18n src="./resources/locales.json"></i18n>
<template>
  <v-dialog v-model="isDisclaimerOpen" width="600" persistent>
    <v-card>
      <v-card-title class="sms-primary-area">
        <span class="headline">{{ $t('title') }}</span>
      </v-card-title>
      <v-card-text class="sms-disclaimer-content">
        {{ $t('defaultDisclaimerText') }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="decline">
          {{ $t('decline') }}
        </v-btn>
        <v-btn class="sms-primary-button" @click="accept">
          {{ $t('accept') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SmsDisclaimerDialog',

  data() {
    return {
      isDisclaimerCall: false
    };
  },

  computed: {
    ...mapGetters('preferences', ['getSettings']),

    isDisclaimerOpen() {
      return this.isDisclaimerCall && !this.getSettings.eula;
    }
  },

  methods: {
    ...mapActions('preferences', ['updateSettings']),

    accept() {
      this.$root.$emit('launch-sms-tour');
      const updatedSettings = {
        eula: true
      };
      this.updateSettings(updatedSettings);
      this.isDisclaimerCall = false;
    },

    decline() {
      this.$root.$emit('close-session');
      const updatedSettings = {
        eula: false
      };
      this.updateSettings(updatedSettings);
      this.isDisclaimerCall = false;
    },

    checkEULA() {
      this.isDisclaimerCall = true;
    },

    close() {
      this.isDisclaimerCall = false;
    }
  }
};
</script>

<style scoped>
.sms-disclaimer-content {
  padding-top: 24px !important;
  font-size: 1rem;
}
</style>
